export { Statistic, StatisticEntry, StatisticRow } from './statistic'
